export enum EnvironmentEnum {
    DEV = 'dev',
    PROD = 'prod',
    STAGING = 'staging',
    WATG = "watg",
    YOLO = "yolo",
    CSKA = "cska"
}